import { concatenar } from './concatenar.js'
import { imprimeSiContiene } from './imprimeSiContiene.js'
import { imprimeSiContieneCondicional } from './imprimeSiContieneCondicional.js'
import { mayusculas } from './mayusculas.js'
import { extraerTexto } from './extraerTexto.js'
import { concatenarArray } from './concatenarArray.js'
import { concatenarArraySi } from './concatenarArraySi.js'
import { existeEnArray } from './existeEnArray.js'
import { buscaEnArray } from './buscaEnArray.js'
import { tabla } from './tabla.js'
import { celda } from './celda.js'
import { celdav2 } from './celdav2.js'
import { repiteEstructura } from './repiteEstructura.js'
import { fechaMostrar } from './fechaMostrar.js'
import { sumarColumna } from './sumarColumna.js'
import { contador } from './contador.js'
import { saltoPagina } from './saltoPagina.js'
import { totalizarArray } from './totalizarArray.js'

export const funcionesPersonalizadas = {
  concatenar,
  imprimeSiContiene,
  imprimeSiContieneCondicional,
  mayusculas,
  extraerTexto,
  concatenarArray,
  concatenarArraySi,
  existeEnArray,
  buscaEnArray,
  tabla,
  celda,
  celdav2,
  repiteEstructura,
  fechaMostrar,
  sumarColumna,
  contador,
  saltoPagina,
  totalizarArray,
}
